var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 9.5C14.9688 11.1699 13.6328 12.4688 12 12.4688C10.3301 12.4688 9.03125 11.1699 9.03125 9.5C9.03125 7.86719 10.3301 6.53125 12 6.53125C13.6328 6.53125 14.9688 7.86719 14.9688 9.5ZM12 8.3125C11.332 8.3125 10.8125 8.86914 10.8125 9.5C10.8125 10.168 11.332 10.6875 12 10.6875C12.6309 10.6875 13.1875 10.168 13.1875 9.5C13.1875 8.86914 12.6309 8.3125 12 8.3125ZM19.125 9.5C19.125 12.7656 14.7832 18.5176 12.8535 20.9297C12.4082 21.4863 11.5547 21.4863 11.1094 20.9297C9.17969 18.5176 4.875 12.7656 4.875 9.5C4.875 5.56641 8.0293 2.375 12 2.375C15.9336 2.375 19.125 5.56641 19.125 9.5ZM12 4.15625C9.03125 4.15625 6.65625 6.56836 6.65625 9.5C6.65625 9.98242 6.80469 10.6875 7.21289 11.6523C7.58398 12.543 8.14062 13.582 8.77148 14.6211C9.84766 16.3281 11.0723 17.9609 12 19.1484C12.8906 17.9609 14.1152 16.3281 15.1914 14.6211C15.8223 13.582 16.3789 12.543 16.75 11.6523C17.1582 10.6875 17.3438 9.98242 17.3438 9.5C17.3438 6.56836 14.9316 4.15625 12 4.15625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.f4cdca0d92b6566461520d822f632363.svg";
export { ForwardRef as ReactComponent };